import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";
import { DEFAULT_CONTENT } from "../defaults";
import { VARIANT_B } from "../variantB";
import { getVariant } from "../lib/ab";

const ContentContext = createContext({ content: DEFAULT_CONTENT, loading: true, refresh: () => {} });

const applyVariant = (base) => {
  if (getVariant() !== "B") return base;
  const merged = { ...base };
  for (const k of Object.keys(VARIANT_B)) {
    const v = VARIANT_B[k];
    merged[k] = Array.isArray(v) ? v : { ...(base[k] || {}), ...v };
  }
  return merged;
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(applyVariant(DEFAULT_CONTENT));
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(applyVariant({ ...DEFAULT_CONTENT, ...data }));
    } catch (e) {
      setContent(applyVariant(DEFAULT_CONTENT));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <ContentContext.Provider value={{ content, loading, refresh }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
